import { render, staticRenderFns } from "./goodsJudgeService.vue?vue&type=template&id=3746924a&scoped=true&"
import script from "./goodsJudgeService.vue?vue&type=script&lang=js&"
export * from "./goodsJudgeService.vue?vue&type=script&lang=js&"
import style0 from "./goodsJudgeService.vue?vue&type=style&index=0&id=3746924a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3746924a",
  null
  
)

export default component.exports